import React from 'react';
import ApiPage from './ApiPage';

const Disclaimer = () => {
  return (
    <ApiPage
      slug="disclaimer"
      fallbackTitle="Disclaimer"
      seoTitle="Disclaimer | WealthDost"
      seoDescription="Read the WealthDost disclaimer for important information about platform content, opinions, and financial responsibility."
      seoPath="/disclaimer"
    />
  );
};

export default Disclaimer;
